const defaultStyles = {
  bar: {
    fill: "lightblue",
    hoverFill: "#2563eb",
    minHeight: 30,
    maxHeight: 45,
    rx: 0, // border-radius
    padding: 0.2,
  },
  axisX: {
    domainColor: "#999",
    domainWidth: 1,
    tickColor: "#ccc",
    tickWidth: 1,
    tickDash: null, // ej: "2,2"
    textColor: "#666",
    textSize: 12,
    textWeight: "normal",
  },
  axisY: {
    domainColor: "#999",
    domainWidth: 1,
    tickColor: "#ccc",
    tickWidth: 1,
    tickDash: null,
    textColor: "#666",
    textSize: 12,
    textWeight: "normal",
  },
  tooltip: {
    background: "rgba(0, 0, 0, 0.8)",
    color: "white",
    fontSize: 13,
    borderRadius: 4,
  },
  animation: {
    enabled: true,
    duration: 0.6, // segundos
    stagger: 80, // ms entre cada barra
  },
  margin: { top: 10, right: 30, bottom: 30, left: 70 },
};

// --- Merge profundo de estilos ---
function mergeStyles(defaults, overrides = {}) {
  const result = { ...defaults };
  for (const key of Object.keys(defaults)) {
    if (
      typeof defaults[key] === "object" &&
      defaults[key] !== null &&
      !Array.isArray(defaults[key])
    ) {
      result[key] = { ...defaults[key], ...overrides[key] };
    } else if (overrides[key] !== undefined) {
      result[key] = overrides[key];
    }
  }
  return result;
}

export { defaultStyles, mergeStyles };
